import FindCampaignMdl from '../uc/findCampaign/FindCampaignMdl';

const BookingReducer = {
    findCampaignMdl: FindCampaignMdl,
};

export default BookingReducer;
